import { createSelector } from '@reduxjs/toolkit';
import { getChannelListState } from './getChannelListState';

export const getSelectedChannelBrand = createSelector(
  getChannelListState,
  (channelList) => channelList.selectedChannelBrand,
);
